import './SearchInfo.less';
import i18n from '@i18n';
import React from 'react';

function SearchInfo({ localizationKey }: { localizationKey: string }) {
    return <div className="no-search-results">{i18n(localizationKey)}</div>;
}

export default SearchInfo;
